import { onMounted, onUnmounted, Ref, ref } from '@nuxtjs/composition-api';
import { IBreakpoint } from '@shared/types/IBreakpoint';

const BREAKPOINTS: IBreakpoint[] = [
  { name: 'desktop', value: 1200 },
  { name: 'tablet', value: 768 },
  { name: 'mobile', value: 0 },
];

const defaultBreakpoint = BREAKPOINTS[2];

const useBreakpoint = (): { breakpoint: Ref<IBreakpoint> } => {
  const breakpoint = ref(defaultBreakpoint);

  function resizeHandler() {
    breakpoint.value =
      BREAKPOINTS.find(
        (_breakpoint) => window.matchMedia(`(min-width: ${_breakpoint.value}px)`).matches,
      ) || defaultBreakpoint;
  }

  onMounted(() => {
    window.addEventListener('resize', resizeHandler);
    resizeHandler();
  });

  onUnmounted(() => window.removeEventListener('resize', resizeHandler));

  return { breakpoint };
};

export default useBreakpoint;
